<template>
  <component
    :is="isMegaMenuMobile ? LazyCmsMegaMenuL3Mobile : LazyCmsMegaMenuL3Desktop"
    v-bind="{ content }"
    @click="handleClick"
  />
</template>

<script lang="ts" setup>
import type { MegaMenuL1Context } from '#content/contexts/megamenu'
import type { MenuItem } from '#types/components/cms/mega-menu'
import { LazyCmsMegaMenuL3Desktop, LazyCmsMegaMenuL3Mobile } from '#components'
import { MegaMenuL1ContextKey, MegaMenuL2ContextKey, MegaMenuMobileContextKey } from '#content/contexts/megamenu'

const props = defineProps<{
  content: MenuItem
}>()

const { $gtm } = useNuxtApp()
const { getActionLinkHandler, isActionLinkOnly } = useCmsActionLink('header:mega-menu')

const eventLabel = formatMegaMenuLevelLabel(getMegaMenuItemLabel(props.content), 3)

const isMegaMenuMobile = inject(MegaMenuMobileContextKey, false)
const { l1 } = inject(MegaMenuL1ContextKey, {} as MegaMenuL1Context)
const l2 = inject(MegaMenuL2ContextKey)

const handleClick = () => {
  if (isActionLinkOnly(props.content.target))
    getActionLinkHandler(props.content.target, getMegaMenuItemLabel(props.content))?.()
  $gtm.push('topNav.onClickTopNavLink', `${toValue(l1)} | ${toValue(l2?.title)} | ${eventLabel}`)
}
</script>
